module.exports = __webpack_public_path__ + "img/rock-480-60.b25471d8.jpg";